import { useResourceAuth } from "./useResourceAuth";
import type { AuthPermission } from "@/types";
import type { OrgAction } from "@/constants/auth";

export function useOrganisationAuth(auth?: Record<string, AuthPermission>) {
  const { can: canAny, getPermission } = useResourceAuth(auth);
  const can = (action: OrgAction): boolean => canAny(action);
  return { can, getPermission };
}
